export default "__VITE_ASSET__CVz$MF6v__"